import React, { useEffect, useState } from "react";
import { adminApi } from "@/api/adminOneClient";

export default function AdminUsers() {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = async () => { setBusy(true); try { const { data } = await adminApi.users(); setRows(data?.users || []); } finally { setBusy(false); } };
  useEffect(()=>{ load(); }, []);
  return (
    <div className="admin-page" data-testid="admin-users">
      <div className="admin-page__head">
        <h2 className="admin-page__title">Users</h2>
        <button className="oracle-btn oracle-btn--ghost oracle-btn--sm" onClick={load} disabled={busy}>{busy?"…":"↻ Refresh"}</button>
      </div>
      <table className="admin-table">
        <thead><tr><th>User ID</th><th>Email</th><th>Role</th><th>Sessions</th><th>Watchlist</th><th>Reports</th><th>High-Risk</th><th>Last Activity</th></tr></thead>
        <tbody>
          {rows.map(u=>(
            <tr key={u.id}>
              <td><code>{(u.id||"").slice(0,8)}…</code></td>
              <td>{u.email || "—"}</td>
              <td><span className={`oracle-role oracle-role--${u.role}`}>{(u.role||"").toUpperCase()}</span></td>
              <td>{u.session_count}</td>
              <td>{u.watchlist_count}</td>
              <td>{u.reports_count}</td>
              <td>{u.high_risk_count}</td>
              <td>{u.last_activity ? new Date(u.last_activity).toLocaleString() : "—"}</td>
            </tr>
          ))}
          {rows.length === 0 && <tr><td colSpan={8} className="oracle-empty" style={{padding:14}}>No users.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
